module.exports = __webpack_public_path__ + "static/img/yfkImg.5fe66040.png";